import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Typography, TypographyProps } from '@mui/material';
import React, { FC } from 'react';
import { useTheme } from '@mui/material/styles';

// --- Types ---
interface BreadcrumbItem {
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}

interface BreadcrumbProps extends TypographyProps {
  breadcrumb: BreadcrumbItem;
  options?: BreadcrumbItem[];
  idx: number;
}

/**
 * Breadcrumb Component
 * Renders a single breadcrumb item with styles and click handling.
 */
const Breadcrumb: FC<BreadcrumbProps> = ({ breadcrumb, options, idx, ...props }) => {
  const theme = useTheme();
  const isLast = idx === (options?.length ?? 0) - 1;

  return (
    <Typography
      {...props}
      sx={{
        display: 'flex',
        alignItems: 'center',
        fontSize: '1rem',
        color: theme.palette.modal.title,
        fontWeight: breadcrumb.isActive ? 600 : 400,
        cursor: breadcrumb.isActive ? 'default' : 'pointer',
        ...props.sx, // allow overriding styles
      }}
      onClick={breadcrumb.onClick}
    >
      {breadcrumb.label}{' '}
      {!isLast && <ArrowForwardIosIcon sx={{ fontSize: '15px', cursor: 'auto', ml: 1 }} />}
    </Typography>
  );
};

export default React.memo(Breadcrumb);
